import { createReducer } from "@reduxjs/toolkit";
import {
    DISABLE_QUICK_ACTIONS,
    ENABLE_QUICK_ACTIONS,
    QuickActionsTypes,
    RESET_QUICK_ACTIONS
} from "../actions/QuickActions/types";

export const initialState: QuickActionsTypes = {
    isEnabled: true,
    selectedType: ""
};

const QuickActions = createReducer(initialState, (builder) => {
    builder
        .addCase(ENABLE_QUICK_ACTIONS, (state) => {
            state.isEnabled = true;
        })
        .addCase(DISABLE_QUICK_ACTIONS, (state) => {
            state.isEnabled = false;
        })
        .addCase(RESET_QUICK_ACTIONS, () => {
            return initialState;
        });
});

export default QuickActions;
